import { render, staticRenderFns } from "./Loja.vue?vue&type=template&id=655ef618&scoped=true&"
import script from "./Loja.vue?vue&type=script&lang=js&"
export * from "./Loja.vue?vue&type=script&lang=js&"
import style0 from "./Loja.vue?vue&type=style&index=0&id=655ef618&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655ef618",
  null
  
)

export default component.exports